import React from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import moment from 'moment';

export default function PaymentDetailsModal({ show, onClose, paymentData }) {
  if (!paymentData) return null;

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return moment(dateString).format('DD/MM/YYYY');
  };

  const formatCurrency = (amount) => {
    if (!amount) return '₹0';
    return `₹${amount.toLocaleString('en-IN')}`;
  };

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton className="bg-light">
        <Modal.Title className="text-primary">
          <i className="mdi mdi-credit-card me-2"></i>
          Payment Details
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="p-4">
        <Row>
          <Col md={6}>
            <div className="mb-3">
              <label className="form-label text-muted fw-semibold">Invoice Number</label>
              <div className="fw-bold fs-6">{paymentData.invoice_number || 'N/A'}</div>
            </div>
          </Col>

          <Col md={6}>
            <div className="mb-3">
              <label className="form-label text-muted fw-semibold">Reference ID</label>
              <div className="fw-bold fs-6 text-primary">{paymentData.reference_id}</div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <div className="mb-3">
              <label className="form-label text-muted fw-semibold">Transaction Date</label>
              <div className="fw-bold fs-6">{formatDate(paymentData.date)}</div>
            </div>
          </Col>

          <Col md={6}>
            <div className="mb-3">
              <label className="form-label text-muted fw-semibold">Transaction Status</label>
              <div>
                <span className={`badge fs-6 text-capitalize bg-${
                  paymentData.transaction_status === 'Complete' ? 'success' : 'secondary'
                }`}>
                  {paymentData.transaction_status}
                </span>
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <div className="mb-3">
              <label className="form-label text-muted fw-semibold">Adjusted Amount</label>
              <div className="fw-bold fs-5 text-success">{formatCurrency(paymentData.adjusted_amount)}</div>
            </div>
          </Col>

          <Col md={6}>
            <div className="mb-3">
              <label className="form-label text-muted fw-semibold">Closing Balance</label>
              <div className="fw-bold fs-5 text-info">{formatCurrency(paymentData.closing_balance)}</div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <div className="mb-3">
              <label className="form-label text-muted fw-semibold">Reason/Description</label>
              <div className="fw-bold fs-6 p-2 bg-light rounded">{paymentData.reason || 'N/A'}</div>
            </div>
          </Col>
        </Row>

        {/* Additional Information Card */}
        <div className="mt-4 p-3 bg-light rounded">
          <h6 className="text-muted mb-3">
            <i className="mdi mdi-information me-2"></i>
            Additional Information
          </h6>
          <Row>
            <Col md={6}>
              <small className="text-muted d-block">Record Created</small>
              <span className="fw-semibold">{formatDate(paymentData.date)}</span>
            </Col>
            <Col md={6}>
              <small className="text-muted d-block">Transaction Type</small>
              <span className="fw-semibold">Payment Adjustment</span>
            </Col>
          </Row>
        </div>
      </Modal.Body>

      <Modal.Footer className="bg-light">
        <Button variant="secondary" onClick={onClose}>
          <i className="mdi mdi-close me-1"></i>
          Close
        </Button>
        <Button variant="primary">
          <i className="mdi mdi-download me-1"></i>
          Export Details
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
